import {useStoreDepartmentsQuery} from "@irati/payrollpay/hooks"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"
import React from "react"
import styled, {css} from "styled-components"
import {PillsBar} from "../../components/PillsBar"
import {useStoreContext} from "../../context/StoreContext"
import {getDepartments} from "../../utils/departments"
import {BannerSection} from "./BannerSection"
import {CycleToWorkSection} from "./CycleToWorkSection"
import {Header} from "./Header"
import {SearchBar} from "./SearchBar"
import {Trending} from "./Trending"

export const Landing = () => {
  const {isHE, schemeType} = useStoreContext()
  const scheme = {schemeType}

  const {data: storeData, load} = useStoreDepartmentsQuery(scheme, {
    fetchPolicy: "cache-and-network"
  })

  const departments = getDepartments(storeData)

  return (
    <Flex direction="column" minHeight="100vh">
      <MainContainer>
        <div className="container">
          <Header />
          <Spacing hideOnDesktop>
            <SearchBar />
          </Spacing>
          <PillsBar departments={departments} load={load} />
        </div>
      </MainContainer>
      <GreySection>
        <div className="container">
          <BannerSection />
          <Trending />
          {!isHE && <CycleToWorkSection />}
        </div>
      </GreySection>
    </Flex>
  )
}

const MainContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
`

const GreySection = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.greys.grey03};
    flex: 1;
    width: 100%;
  `}
`
